module.exports = __webpack_public_path__ + "img/polygon-view-anchor.bcecb48.png";